<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>
                    {{ $t('Delivery.DeliveryOrders.DeliveryOrders') }}
                </v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end">
                <genericBtnComponent :ClickFun="navigateToInitializedDeliveryOrders" svg="2"
                    :Title="$t('Delivery.initializedDeliveryOrders')" v-if="IsAdmin()"/>
            </div>
        </div>
        <v-card elevation="0">
            <DelivryOrdersList />
        </v-card>
    </div>
</template>
<script>
import DelivryOrdersList from "./DelivryOrdersList.vue";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import { isClient } from "@/api/index";

export default {
    components: {
        DelivryOrdersList,
        genericBtnComponent
    },
    data() {
        return {
        }
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.DeliveryOrders');
    },
    methods: {
        navigateToInitializedDeliveryOrders() {
            this.$router.push({ name: 'initializedDeliveryOrders' });
        },
        IsAdmin() {
            return isClient();
        },
    }
};

</script>
